module.exports = __webpack_public_path__ + "static/media/game-icon-play.3172cd22.png";